module.exports = __webpack_public_path__ + "static/media/placeholder-image.04060eee.jpeg";